import { render, staticRenderFns } from "./setReminder.vue?vue&type=template&id=b33aa334&"
import script from "./setReminder.vue?vue&type=script&lang=js&"
export * from "./setReminder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports